import { EDGE_TYPE, MENU_ITEM_TYPE, MENU_SECTION_TYPE } from '@ent/entity-type';
import { stableId } from '../zero/stable-values';

/**
 * Deterministic ids the optimistic client mutators and the server mutators
 * must agree on, so the optimistic row and the replicated server row are the
 * same row.
 */

/** The unnamed section every menu starts with (menus.create). */
export function defaultMenuSectionId(menuId: string): string {
  return stableId(MENU_SECTION_TYPE, menuId, 'default');
}

/** The item the compatibility `menus.addRecipe` mutator writes. */
export function compatMenuItemId(menuId: string, recipeId: string): string {
  return stableId(MENU_ITEM_TYPE, menuId, recipeId);
}

/** The optimistic menu -> recipe edge (same id `menus.addRecipe` used). */
export function menuRecipeEdgeId(menuId: string, recipeId: string): string {
  return stableId(EDGE_TYPE, menuId, 'recipe', recipeId);
}
